var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemComment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M20 2c1.104 0 2 .899 2 2.006v12.038a2.004 2.004 0 0 1-2 2.006H8.333l-4.714 3.733a.98.98 0 0 1-.614.217C2.487 22 2 21.59 2 20.996V4.006C2 2.9 2.896 2 4 2Zm0 2.006H4v14.92l3.094-2.45.545-.432H20zm-6 7.022a1 1 0 0 1 1 1.003 1 1 0 0 1-1 1.003H8a1 1 0 0 1-1-1.003 1 1 0 0 1 1-1.003Zm2-4.011a1 1 0 0 1 1 1.003 1 1 0 0 1-1 1.003H8A1 1 0 0 1 7 8.02a1 1 0 0 1 1-1.003Z"
})));
export default SvgGemComment;